"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInsightDataView = void 0;
var tslib_1 = require("tslib");
var base_1 = require("../base");
var useExecutionDataView_1 = require("./useExecutionDataView");
var useInsight_1 = require("./useInsight");
/**
 * React hook to get data for a specific insight.
 *
 * @beta
 */
function useInsightDataView(config, deps) {
    var insightRef = config.insight, sorts = config.sorts, dateFormat = config.dateFormat, dimensions = config.dimensions, filters = config.filters, window = config.window;
    var backend = base_1.useBackendStrict(config.backend, "useInsightDataView");
    var workspace = base_1.useWorkspaceStrict(config.workspace, "useInsightDataView");
    var effectiveDeps = deps !== null && deps !== void 0 ? deps : [];
    var insightPromise = useInsight_1.useInsight({ insight: insightRef, backend: backend, workspace: workspace }, effectiveDeps);
    var insightExecution = insightPromise.result &&
        backend.workspace(workspace).execution().forInsightByRef(insightPromise.result, filters);
    if (insightExecution) {
        if (sorts) {
            var resolvedSorts = typeof sorts === "function" ? sorts(insightExecution.definition) : sorts;
            insightExecution = insightExecution.withSorting.apply(insightExecution, tslib_1.__spread(resolvedSorts));
        }
        if (dimensions) {
            var resolvedDimensions = typeof dimensions === "function" ? dimensions(insightExecution.definition) : dimensions;
            insightExecution = insightExecution.withDimensions.apply(insightExecution, tslib_1.__spread(resolvedDimensions));
        }
        if (dateFormat) {
            var resolvedDateFormat = typeof dateFormat === "function" ? dateFormat(insightExecution.definition) : dateFormat;
            insightExecution = insightExecution.withDateFormat(resolvedDateFormat);
        }
    }
    var executionDataViewPromise = useExecutionDataView_1.useExecutionDataView({
        execution: insightExecution,
        window: window,
        backend: backend,
        workspace: workspace,
    }, deps);
    var cancelablePromises = [insightPromise, executionDataViewPromise];
    return {
        result: executionDataViewPromise.result,
        error: base_1.resolveUseCancelablePromisesError(cancelablePromises),
        status: base_1.resolveUseCancelablePromisesStatus(cancelablePromises),
    };
}
exports.useInsightDataView = useInsightDataView;
//# sourceMappingURL=useInsightDataView.js.map